// extracted by mini-css-extract-plugin
export default {"root":"FjhdYT1yLKUCKxVAj5EO","marks":"NtK9BD0sJtZewcGqLrgr","marksOverflowed":"ZHWm6KYmOT9X_J37wpN3","placeHolderShimmer":"kMK5w1273z4vLnwLyF9Y"};